module.exports = __webpack_public_path__ + "media/images/vp/samples/05-aab98fa76719f732c57388a17f4d74c8.jpg";